import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Tabs from 'components/Tabs';
import { connect } from 'react-redux';
import Overview from './Overview';
import MenuSections from './MenuSections';
import ChitChat from 'components/ChitChat/ChitChat';
import Files from 'components/Files';
// import PaymentHistory from './PaymentHistory';

const styles = {
  container: {
    display: 'flex',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
};

const tabNames = ["Overview", "Menu", "Chit Chat", "Files"];

class EventDetails extends Component {
  state = {
    selectedTab: 0,
    imgSrc: '',
  };

  componentDidMount() {

    const savedTab = sessionStorage.getItem('overviewSelectedTab');

    if (savedTab !== null) {
      this.setState({ selectedTab: Number(savedTab) });
      sessionStorage.removeItem('overviewSelectedTab');
    }
    this.loadImage();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.booking !== this.props.booking) {
      this.loadImage();
    }
  };

  loadImage = () => {
    if (!this.props.booking) {
      return;
    } /*
    this.props.getImage(this.props.booking.id).then(image => {
      if (image.content) {
        const imgSrc = `data:image/gif;base64, ${image.content}`;

        this.setState({ imgSrc });
      };
    });*/
  };

  tabChanged = newValue => {
    // Validate tab index
    if (newValue >= 0 && newValue < tabNames.length) {
      this.setState({ selectedTab: newValue });
    }
  };

  render() {
    const { classes, booking } = this.props;
    const {
      selectedTab,
      imgSrc,
    } = this.state;

    return (
      <div className={classes.container}>
        <div className={classes.content}>
          <Tabs value={selectedTab} tabNames={tabNames} onChange={this.tabChanged} />
          {selectedTab === 0 && <Overview booking={booking} imgSrc={imgSrc} />}
          {selectedTab === 1 && <MenuSections booking={booking} />}
          {selectedTab === 2 && <ChitChat booking={booking} />}
          {selectedTab === 3 && <Files bookingId={booking.id} booking={booking} />}
          {/* {selectedTab === 4 && <PaymentHistory paymentHistory={booking.payments} />} */}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  // getImage,
};

export default connect(undefined, mapDispatchToProps)(withStyles(styles)(EventDetails));
